import { makeAutoObservable } from 'mobx';
import _ from 'lodash';

class TimelineSectionViewModel {
  entries = [];
  showEmailInput = false;
  showFileUpload = false;
  showInterviewGuide = false;
  stage;
  candidate;

  constructor(candidate, entries) {
    makeAutoObservable(this);

    this.candidate = candidate;

    if (entries) {
      this.entries = entries;
      this.stage = this.entries[0].funnelStage;
    }
  }

  get positiveSentimentCount() {
    return _.filter(this.entries, { isFeedback: true, isPositiveSentiment: true }).length;
  }

  get negativeSentimentCount() {
    return _.filter(this.entries, { isFeedback: true, isNegativeSentiment: true }).length;
  }

  get isEmpty() {
    return !this.entries.length;
  }

  get orderedEntries() {
    return _.orderBy(this.entries, ['createdAt'], ['desc']);
  }

  get enabled() {
    return !this.isEmpty || this.showEmailInput || this.showFileUpload || this.showInterviewGuide;
  }
}

export default TimelineSectionViewModel;
